/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Review mode has 3 tabs which show different "response display" ("review session substate") for single item.
 */
export const reviewResponseDisplays = {
    answer: 'answer',
    question: 'question',
    correct: 'correct'
};
